import { render, staticRenderFns } from "./cambiosInterna.vue?vue&type=template&id=28acf922&"
import script from "./cambiosInterna.vue?vue&type=script&lang=js&"
export * from "./cambiosInterna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports